import { render, staticRenderFns } from "./Formacao.vue?vue&type=template&id=17c0111e&scoped=true"
import script from "./Formacao.vue?vue&type=script&lang=js"
export * from "./Formacao.vue?vue&type=script&lang=js"
import style0 from "./Formacao.vue?vue&type=style&index=0&id=17c0111e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c0111e",
  null
  
)

export default component.exports